import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "homePage",
  id: "home"
}

import BackgroundNav from './Nav-bar.vue'
    import ButtonNav from './Button-nav.vue';
    import Carousel from './Carousel-body.vue'
    import FooterHome from './Footer-Home.vue';
  
  
export default /*@__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

  
    
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BackgroundNav),
    _createVNode(ButtonNav),
    _createVNode(Carousel),
    _createVNode(FooterHome)
  ]))
}
}

})